<template>
  <div class="page">
    <div class="div-header-select">
      <div class="div-center">
        <div style="width: 60px">搜索：</div>
        <el-input
          placeholder="请输入姓名或手机号"
          maxlength="13"
          v-model="phoneOrName"
          clearable
          @clear="initQuery"
          size="medium"
          @keyup.enter.native="initQuery"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="initQuery"
          ></el-button>
        </el-input>
      </div>
      <div class="div-center">
        <el-button size="medium" @click="showTopupDialog(0, '')"
          >充值</el-button
        >
        <el-button size="medium" @click="showTopupDialog(1, '')"
          >退款</el-button
        >
      </div>
    </div>
    <el-row>
      <el-col :span="19">
        <main>
          <div>
            <el-table
              :data="listData"
              @header-click="headerClickHouseName"
              style="width: 100%"
              height="calc(100vh - 200px)"
              ref="tableBalances"
            >
              <template slot="empty">
                <img
                  src="../../assets/list-none.png"
                  alt=""
                  width="400"
                  class="table-empty"
                />
                <div>空荡荡的～暂无数据！</div>
              </template>
              <el-table-column prop="name" label="姓名" align="center">
              </el-table-column>
              <el-table-column
                prop="phone"
                width="110vw"
                label="手机号"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="balance" label="用户余额" align="center">
                <template slot-scope="scope">
                  <strong>{{ numFormat(scope.row.balance) }}</strong>
                </template>
              </el-table-column>
              <!-- prop="pricingsName" -->
              <el-table-column
                v-if="!receiptInput"
                prop="pricingsName"
                label="合同房源"
                align="left"
                key="receipt_1"
              >
                <template slot="header">
                  <div style="color: #409eff">
                    <span>合同房源 </span>
                    <i class="el-icon-search"></i>
                  </div>
                </template>
                <template slot-scope="scope">
                  <span
                    v-for="house in scope.row.houses"
                    :key="house.id"
                    align="center"
                    style="padding: 5px 5px"
                  >
                    <el-button
                      type="primary"
                      round
                      size="mini"
                      style="padding: 5px 10px"
                    >
                      {{ house.areaName }}：{{ house.name }}
                    </el-button>
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                v-if="receiptInput"
                prop="pricingsName"
                label="合同房源"
                align="left"
                key="receipt_2"
              >
                <template slot="header" slot-scope="scope">
                  <el-input
                    v-model="queryHouseName"
                    size="mini"
                    placeholder="合同房源"
                    clearable
                    v-focus
                    maxlength="50"
                    @blur="recoverHouseName"
                    @keyup.enter.native="query(0)"
                    @clear="clearInput"
                  />
                </template>
                <template slot-scope="scope">
                  <span
                    v-for="house in scope.row.houses"
                    :key="house.id"
                    align="center"
                    style="padding: 5px 5px"
                  >
                    <el-button
                      type="primary"
                      round
                      size="mini"
                      style="padding: 5px 10px"
                    >
                      {{ house.areaName }}：{{ house.name }}
                    </el-button>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    @click="userBalancesDetail(scope.row)"
                    >明细</el-button
                  >
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    @click="showTopupDialog(0, scope.row.phone)"
                    >充值</el-button
                  >
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    @click="showTopupDialog(1, scope.row.phone)"
                    >退款</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </main>

        <footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIdx"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="itemTotal"
            :page-sizes="[10, 20, 30, 40, 50]"
          >
          </el-pagination>
        </footer>
      </el-col>
      <el-col :span="4">
        <div>
          <div id="recharge" style="width: 300px; height: 200px"></div>
          <div
            id="refund"
            style="margin-top: 50px; width: 300px; height: 200px"
          ></div>
          <div
            id="balance"
            style="margin-top: 50px; width: 300px; height: 200px"
          ></div>
        </div>
      </el-col>
    </el-row>
    <!-- 用户明细 -->
    <el-dialog
      :visible.sync="userDetailsDialogVisible"
      title="余额明细"
      top="6vh"
      width="75vw"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-center">
        <div>
          <el-radio border size="small ">
            <span>{{ this.detailName }} - {{ this.detailPhone }}</span>
          </el-radio>
        </div>
        <div class="div-2-title"></div>
        <el-date-picker
          style="width: 400px"
          size="medium"
          v-model="daterange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <el-table :data="listDataDetail" height="calc(100vh - 300px)">
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400px"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column prop="amount" label="变更金额" align="center">
          <template slot-scope="scope">
            <strong v-if="scope.row.amount < 0" style="color: red">{{
              numFormat(scope.row.amount)
            }}</strong>
            <strong v-else style="color: green">{{
              numFormat(scope.row.amount)
            }}</strong>
          </template>
        </el-table-column>
        <el-table-column prop="billName" label="账单" align="center">
        </el-table-column>
        <el-table-column prop="orderName" label="订单" align="center">
        </el-table-column>
        <el-table-column
          prop="changeTime"
          width="150px"
          label="变更时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="comment"
          width="330px"
          label="备注"
          align="center"
        >
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          @size-change="handleSizeChangeDetails"
          @current-change="handleCurrentChangeDetails"
          :current-page="pageIdxDetails"
          :page-size="pageSizeDetails"
          layout="total, sizes, prev, pager, next, jumper"
          :total="itemTotalDetails"
          :page-sizes="[10, 20, 30, 40, 50]"
        >
        </el-pagination>
      </footer>
    </el-dialog>
    <!-- 用户退款记录 -->
    <el-dialog
      :visible.sync="userRefundsDialogVisible"
      title="退款记录"
      top="6vh"
      width="80vw"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-center">
        <div>
          <el-radio border size="small ">
            <span>{{ this.refundName }} - {{ this.refundPhone }}</span>
          </el-radio>
        </div>
      </div>
      <el-table :data="listDataRefund" height="calc(100vh - 300px)">
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400px"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column prop="fee" label="变更金额" align="center">
          <template slot-scope="scope">
            <strong style="color: red">-{{ numFormat(scope.row.fee) }}</strong>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="订单名称" align="center">
        </el-table-column>
        <el-table-column prop="type" label="退款方式" align="center">
        </el-table-column>
        <el-table-column prop="state" label="状态" align="center">
        </el-table-column>
        <el-table-column label="付款人" align="center">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              content="test"
              width="400px"
              trigger="click"
            >
              <el-table :data="scope.row.payers">
                <el-table-column
                  width="150"
                  property="realname"
                  label="真实姓名"
                ></el-table-column>
                <el-table-column
                  width="150"
                  property="phone"
                  label="电话"
                ></el-table-column>
              </el-table>
              <div slot="reference" class="name-wrapper">
                <el-tag style="cursor: pointer" size="medium">{{
                  scope.row.payers ? scope.row.payers[0].realname : ""
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="收款人" align="center">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              content="test"
              width="400px"
              trigger="click"
            >
              <el-table :data="scope.row.receivers">
                <el-table-column
                  width="150"
                  property="realname"
                  label="真实姓名"
                ></el-table-column>
                <el-table-column
                  width="150"
                  property="phone"
                  label="电话"
                ></el-table-column>
              </el-table>
              <div slot="reference" class="name-wrapper">
                <el-tag style="cursor: pointer" size="medium">{{
                  scope.row.receivers ? scope.row.receivers[0].realname : ""
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="paidTime"
          width="150px"
          label="支付时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="createdTime"
          width="150px"
          label="退款发起时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="comment"
          width="330px"
          label="备注"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-show="scope.row.showQuery"
              type="primary"
              plain
              size="mini"
              @click="queryRefundCheck(scope.row)"
              >查询</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      width="500px"
      :visible.sync="dialogTopupVisible"
      :title="this.titleName"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" :model="formTopupInput" label-width="80px">
        <div
          v-if="queryRefundButtonVisible"
          style="margin-bottom: 5px; backround: #e6a23c"
          v-show="this.isRefund"
        >
          <el-button
            size="mini"
            round
            @click="refundClick"
            icon="el-icon-search"
            type="warning"
            >{{ this.refundTitle }}</el-button
          >
        </div>
        <div class="div-2">
          <el-row>
            <el-col :span="14">
              <el-form-item label="手机号" style="width: 300px">
                <el-input
                  clearable
                  @clear="getFormTopupInput"
                  maxlength="11"
                  v-model="queryPhone"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <el-button @click="getFormTopupInput(queryPhone)" size="medium"
                  >查询</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-show="this.showState">
          <div class="div-2">
            <el-form-item
              label="姓名："
              style="margin-left: 45px; margin-bottom: 0px"
            >
              <span>{{ this.formTopupInput.name }} </span>
            </el-form-item>
          </div>
          <div class="div-2">
            <el-form-item
              label="房号："
              style="margin-left: 45px; margin-bottom: 0px"
            >
              <span
                v-for="(item, index) in Object.keys(this.formTopupInput.houses)"
                :key="index"
              >
                <!-- <el-button round size="mini" v-if="index==0" style="padding: 5px 5px;margin-right: 10px; margin-left: -25px;"  type="info" plain>
                {{formTopupInput.houses[item]}}
                </el-button> -->
                <el-button
                  round
                  size="mini"
                  style="padding: 5px 5px; margin-right: 10px"
                  type="info"
                  plain
                >
                  {{ formTopupInput.houses[item] }}
                </el-button>
              </span>
            </el-form-item>
          </div>
          <div class="div-2">
            <el-form-item label="余额：" style="margin-left: 45px">
              <span>{{ numFormat(this.formTopupInput.balance) }} </span>
              <!-- <span>余额：   {{this.formTopupInput.balance}} </span> -->
            </el-form-item>
          </div>
          <div v-show="!this.isRefund" class="div-2">
            <el-form-item label="充值金额">
              <el-input-number
                v-model="formTopupInput.amount"
                :max="9999999999"
                style="width: 335px"
                :precision="2"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </div>
          <div v-show="this.isRefund" class="div-2">
            <el-form-item label="退款金额">
              <el-input-number
                v-model="formTopupInput.amount"
                :max="9999999999"
                style="width: 335px"
                :precision="2"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </div>
          <div v-show="this.isRefund" class="div-2">
            <el-form-item label="退款方式">
              <template>
                <el-radio v-model="formTopupInput.radio" label="微信退款"
                  >微信退款</el-radio
                >
                <el-radio v-model="formTopupInput.radio" label="人工退款"
                  >人工退款</el-radio
                >
              </template>
            </el-form-item>
          </div>
          <div class="div-2">
            <el-form-item label="备注" style="width: 415px">
              <el-input
                type="textarea"
                maxlength="208"
                v-model="formTopupInput.comment"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTopupVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="submitTopup"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Loading } from "element-ui";
import { Decimal } from "decimal.js";
import { MessageBox } from "element-ui";
import mixins from "../../minix";

let _vue;

export default {
  mixins: [mixins],
  name: "home",

  data() {
    return {
      receiptInput: false,
      queryHouseName: "", //查询合同房源
      tableHeight: "", //表格高度
      isRunDrawLine: false, //是否执行饼图数据查询
      daterange: "",
      pageIdx: 0,
      queryPhone: "",
      showState: false,
      isRefund: false,
      titleName: "",
      refundTitle: "查询退款记录",
      queryRefundButtonVisible: true,
      dialogTopupVisible: false,
      itemTotal: 0,
      pageIdxDetails: 0,
      pageSizeDetails: 10,
      itemTotalDetails: 0,
      quertDetailData: {},
      detailPhone: "",
      detailName: "",
      refundName: "",
      refundPhone: "",
      userDetailsDialogVisible: false,
      userRefundsDialogVisible: false,
      listData: [],
      listDataDetail: [],
      listDataRefund: [],
      phone: "",
      phoneOrName: "",
      pricings: [],
      house: {
        id: "",
        name: "",
        areaName: "",
      },
      formInput: {},
      formTopupInput: {
        houses: [],
        balance: 0,
        amount: 0,
      },
      option: {
        title: {
          text: 0,
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: (v) => {
            return v.data.name + " ￥" + this.numFormat(v.data.value);
          },
        },
        legend: {
          orient: "vertical",
          // left: 0,
          bottom: 45,
          right: 0,
          // top: 80,
        },
        series: [
          {
            type: "pie",
            radius: "55%",
            data: [],
            label: {
              normal: {
                position: "inner",
                show: false,
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");
    this.setTableHeight();
    this.query(0);
    _vue = this;
  },

  watch: {
    state() {
      this.initQuery();
    },

    areaIDSelect() {
      this.initQuery();
    },
    daterange() {
      this.pageIdxDetails = 0;
      this.getUserBalancesDetailList(0);
    },
  },

  mounted() {
    this.drawLine();
    // *****监听页面窗口改变函数  设置其宽高值 *****
    window.onresize = () => {
      return (() => {
        this.setTableHeight();
      })();
    };
  },
  methods: {
    queryRefundCheck(row) {
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
      // 微信退款方式 ==>查询退款结果
      axios({
        method: "post",
        url: "wallets/refundcheck",
        data: { orgID: row.orgID, orderID: row.id },
      })
        .then((rc) => {
          //refundcheck
          if (rc.data.code === 0) {
            if (rc.data.data.state == "成功") {
              this.$message.success("退款成功");
              for (let index = 0; index < this.listDataRefund.length; index++) {
                const ldr = this.listDataRefund[index];
                if (ldr.id == row.id) {
                  this.listDataRefund[index].paidTime = Utils.long2second(
                    rc.data.data.paidTime * 1000
                  );
                  this.listDataRefund[index].state = "已支付";
                  this.listDataRefund[index].showQuery = false;
                }
              }
            } else if (rc.data.data.state == "处理中") {
              this.$message.warning("退款正在处理中，请稍后再查询");
            } else if (rc.data.data.state == "失败") {
              this.$message.error(rc.data.data.reason);
              for (let index = 0; index < this.listDataRefund.length; index++) {
                const ldr = this.listDataRefund[index];
                if (ldr.id == row.id) {
                  this.listDataRefund[index].state = "未支付";
                  this.listDataRefund[index].comment = rc.data.data.reason;
                  this.listDataRefund[index].showQuery = false;
                }
              }
            } else {
              this.$message.error("无效的退款状态：" + rc.data.data.state);
            }
          } else {
            this.$message.error(rc.data.message);
          }
        })
        .catch((e) => {console.error(e)})
        .finally(() => {
          loading.close();
        });
    },
    refundClick() {
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
      let refundData = {
        userID: this.formTopupInput.id,
        orgID: this.$route.query.orgID,
        pageSize: 100,
        pageIdx: 0,
      };
      axios({
        method: "post",
        url: "wallets/refunds",
        data: refundData,
      })
        .then((res) => {
          this.listDataRefund = [];
          if (res.data.code != 0) {
            this.$message.error(res.data.message);
            return;
          }
          if (res && res.data && res.data.data) {
            if (res.data.hasProcessingRefund) {
              this.refundTitle = "该用户存在正在处理中的退款";
            } else {
              this.refundTitle = "查询退款记录";
            }

            this.refundPhone = this.formTopupInput.phone;
            this.refundName = this.formTopupInput.name;
            res.data.data.forEach((item) => {
              item.fee = new Decimal(item.fee).div(new Decimal(100)).toNumber();
              if (item.state == "支付中") {
                item.showQuery = true;
              } else {
                item.showQuery = false;
              }
              if (item.state == "已支付") {
                item.paidTime = Utils.long2second(item.paidTime * 1000);
              } else {
                item.paidTime = "";
              }
              item.createdTime = Utils.long2second(item.createdTime * 1000);
              item.payers = [item.payer];
              item.receivers = [item.receiver];
              this.listDataRefund.push(item);
            });
          }
          if (this.listDataRefund.length > 0) {
            this.userRefundsDialogVisible = true;
          } else {
            this.$message.error("无退款记录");
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    },
    clearInput() {
      this.receiptInput = false;
      this.query(0);
    },
    recoverHouseName(event) {
      if (!this.queryHouseName) {
        this.receiptInput = false;
      }
    },
    headerClickHouseName(column, event) {
      if (column.property == "pricingsName") {
        this.receiptInput = true;
      }
    },
    setTableHeight() {
      this.tableHeight = document.documentElement.clientHeight * 0.8 - 50;
    },
    // 获取饼图数据
    drawLine() {
      let data = {
        orgID: this.$route.query.orgID,
      };
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
      axios({
        method: "post",
        url: "wallets/count",
        data: data,
      })
        .then((value) => {
          this.isRunDrawLine = false;
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
            return;
          }
          if (value && value.data) {
            const item = value.data.data;
            // 如果总充值金额大于零  制作饼图

            // 基于准备好的dom，初始化echarts实例
            let rechargePie = this.$echarts.init(
              document.getElementById("recharge")
            );
            let refundPie = this.$echarts.init(
              document.getElementById("refund")
            );
            let balancePie = this.$echarts.init(
              document.getElementById("balance")
            );
            let recharge = { ...this.option };
            let refund = { ...this.option };
            let balance = { ...this.option };
            let topupTotal = 0; //总充值金额
            let topupOffline = 0; //后台充值
            let topupOnline = 0; //线上充值
            let refundTotal = 0; //总退款金额
            let refundOffline = 0; //后台退款
            let refundOnline = 0; //线上退款
            let balanceTotal = 0; //总余额
            let topupBill = 0; // 账单转入金额
            if (item.topupTotal > 0) {
              topupTotal = new Decimal(item.topupTotal)
                .div(new Decimal(100))
                .toNumber(); //	总充值金额，单位分
              topupOffline = new Decimal(item.topupOffline)
                .div(new Decimal(100))
                .toNumber(); //	后台充值金额，单位分
              topupOnline = new Decimal(item.topupOnline)
                .div(new Decimal(100))
                .toNumber(); //线上充值金额，单位分，目前线上充值只有微信渠道
              refundTotal = new Decimal(item.refundTotal)
                .div(new Decimal(100))
                .toNumber(); //	总退款金额，单位分
              refundOffline = new Decimal(item.refundOffline)
                .div(new Decimal(100))
                .toNumber(); //后台退款金额，单位分
              refundOnline = new Decimal(item.refundOnline)
                .div(new Decimal(100))
                .toNumber(); //	线上退款金额，单位分，目前线上退款只有微信渠道
              balanceTotal = new Decimal(item.balanceTotal)
                .div(new Decimal(100))
                .toNumber(); //总余额，单位分
              topupBill = new Decimal(item.topupBill)
                .div(new Decimal(100))
                .toNumber(); //账单转入金额，单位分
            }
            // 负数不可显示饼图
            // 总充值金额饼图
            recharge.title.text = "￥" + this.numFormat(topupTotal);
            recharge.title.subtext = "总充值金额";
            recharge.series[0].data = [
              // {value:300,name:'后台充值'},
              // {value:200,name:'线上充值'},
              { value: topupOffline, name: "人工充值" },
              { value: topupOnline, name: "微信充值" },
              { value: topupBill, name: "账单转入" },
            ];
            recharge.series[0].itemStyle = {
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
              normal: {
                color: function (params) {
                  //自定义颜色
                  var colorList = ["#CC7A00", "#FFBB55", "#FFD633"];
                  return colorList[params.dataIndex];
                },
              },
            };
            rechargePie.setOption(recharge);
            // 总退款饼图
            refund.title.text = "￥" + this.numFormat(refundTotal);
            refund.title.subtext = "总退款金额";
            refund.series[0].data = [
              { value: refundOffline, name: "人工退款" },
              { value: refundOnline, name: "微信退款" },
            ];

            refund.series[0].itemStyle = {
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
              normal: {
                color: function (params) {
                  //自定义颜色
                  var colorList = ["#777777", "#999999"];
                  return colorList[params.dataIndex];
                },
              },
            };
            refundPie.setOption(refund);
            // 总余额饼图
            balance.title.text = "￥" + this.numFormat(balanceTotal);
            balance.title.subtext = "总余额";
            balance.series[0].data = [{ value: balanceTotal, name: "总余额" }];
            balance.series[0].itemStyle = {
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
              normal: {
                color: function (params) {
                  //自定义颜色
                  var colorList = ["#FFC266"];
                  return colorList[params.dataIndex];
                },
              },
            };
            balancePie.setOption(balance);
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    },
    //查询账单信息

    getFormTopupInput(row) {
      this.showState = false;
      this.formTopupInput = {
        houses: [],
        balance: 0,
        amount: 0,
      };
      if (!row) {
        this.$message.error("请输入手机号");
        return;
      }
      let data = {
        phone: row,
        orgID: this.$route.query.orgID,
        pageSize: this.pageSize,
        pageIdx: 0,
      };
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
      axios({
        method: "post",
        url: "wallets",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
            this.showState = false;
            return;
          }
          if (value && value.data && value.data.data) {
            if (value.data.data.length == 0) {
              this.$message.error("未查询到数据");
              this.showState = false;
              return;
            }
            if (value.data.hasProcessingRefund) {
              this.refundTitle = "该用户存在正在处理中的退款";
            } else {
              this.refundTitle = "查询退款记录";
            }
            let data = {
              id: value.data.data[0].id,
              name: value.data.data[0].name,
              phone: value.data.data[0].phone,
              // housesName: value.data.data[0].houses[0].name,
              houses: value.data.data[0].houses,
              balance: value.data.data[0].balance,
              comment: "",
            };
            //将单位元转分
            data.balance = new Decimal(data.balance)
              .div(new Decimal(100))
              .toNumber();

            //  data.amount = data.amount / 100
            if (this.titleName == "退款") {
              data.amount = data.balance;
              data.radio = "微信退款";
            } else {
              data.amount = 0;
            }
            this.formTopupInput = data;
            this.formTopupInput.houses = [];
            value.data.data[0].houses.forEach((item) => {
              this.formTopupInput.houses.push(item.areaName + " " + item.name);
            });

            this.showState = true;
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    },
    showTopupDialog(state, phone) {
      this.showState = false;
      this.queryPhone = "";
      this.formTopupInput = {
        id: "",
        name: "",
        phone: "",
        houses: [],
        balance: 0,
        amount: 0,
        comment: "",
      };
      //充值
      if (state == 0) {
        this.titleName = "充值";
        this.isRefund = false;
      } else if (state == 1) {
        //退款
        this.titleName = "退款";
        this.isRefund = true;
      }
      if (phone) {
        this.queryPhone = phone;
        this.getFormTopupInput(phone);
      }
      this.dialogTopupVisible = true;
      this.queryRefundButtonVisible = true;
      this.refundTitle = "查询退款记录";
    },

    //退款\充值
    submitTopup() {
      if (!this.formTopupInput.id) {
        this.$message.error("请选择账 " + this.titleName + " 账户");
        return;
      }
      if (this.formTopupInput.amount === 0) {
        this.$message.error("请输入 " + this.titleName + " 金额");
        return;
      }
      let data = {
        userID: this.formTopupInput.id,
        amount: new Decimal(this.formTopupInput.amount).toNumber(),
        comment: this.formTopupInput.comment,
        orgID: this.$route.query.orgID,
        type: this.formTopupInput.radio,
      };

      let reqUrl = "";
      if (this.titleName == "充值") {
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
        reqUrl = "wallets/topup";
        //将单位元转分
        data.amount = new Decimal(data.amount).mul(new Decimal(100)).toNumber();
        // data.amount = data.amount * 100
        axios({
          method: "post",
          url: reqUrl,
          data: data,
        })
          .then((value) => {
            if (value.data.code === 0) {
              this.$message.success(value.data.message);
              this.dialogTopupVisible = false;
              this.isRunDrawLine = true;
            } else {
              this.$message.error(value.data.message);
            }
          })
          .catch(() => {})
          .finally(() => {
            loading.close();
            this.query(0);
          });
      } else if (this.titleName == "退款") {
        if (this.formTopupInput.amount > this.formTopupInput.balance) {
          this.$message.error(this.titleName + "金额不能大于账户余额");
          return;
        }
        reqUrl = "wallets/refund";
        let hintMsg = "";
        if (data.type == "微信退款") {
          hintMsg =
            "<strong>将通过微信向用户退款 <strong style='color:red'>" +
            this.numFormat(data.amount) +
            "</strong> 元，资金将直接进入用户微信余额，确认执行退款吗？</strong>";
        } else if (data.type == "人工退款") {
          hintMsg =
            "<strong>将通过人工方式向用户退款 <strong style='color:red'>" +
            this.numFormat(data.amount) +
            "</strong> 元，资金由工作人员线下操作，确认执行退款吗？</strong>";
        }

        //将单位元转分
        data.amount = new Decimal(data.amount).mul(new Decimal(100)).toNumber();
        // data.amount = data.amount * 100
        MessageBox.confirm(hintMsg, data.type + "确认提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const loading = Loading.service({
              lock: true,
              text: "正在请求中...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.1)",
            });
            axios({
              method: "post",
              url: reqUrl,
              data: data,
            })
              .then((value) => {
                if (value.data.code === 0) {
                  let res = value.data.data;
                  if (res.type == "微信退款") {
                    // 微信退款方式 ==>查询退款结果
                    axios({
                      method: "post",
                      url: "wallets/refundcheck",
                      data: {
                        orgID: this.$route.query.orgID,
                        orderID: res.orderID,
                      },
                    })
                      .then((rc) => {
                        let isClose = false;
                        if (rc.data.code === 0) {
                          if (rc.data.data.state == "成功") {
                            this.$message.success("退款成功");
                            isClose = true;
                          } else if (rc.data.data.state == "处理中") { 
                            this.$message.warning(
                              "退款正在处理中，请稍后再查询"
                            );
                            isClose = true;
                          } else if (rc.data.data.state == "失败") {
                            this.$message.error(rc.data.data.reason);
                          } else {
                            this.$message.error(
                              "无效的退款状态：" + rc.data.data.state
                            );
                          }
                        } else {
                          this.$message.error(value.data.message);
                        }
                        if (isClose) {
                          this.dialogTopupVisible = false;
                          this.isRunDrawLine = true;
                        }
                      })
                      .catch(() => {});
                  } else {
                    this.dialogTopupVisible = false;
                    this.isRunDrawLine = true;
                    this.$message.success("退款成功");
                  }
                } else {
                  this.$message.error(value.data.message);
                }
              })
              .catch(() => {})
              .finally(() => {
                loading.close();
                this.query(0);
              });
          })
          .catch(() => {});
      }
    },

    handleCurrentChange(val) { 
      this.pageIdx = val;
      this.query(val - 1);
      this.$refs.tableBalances.bodyWrapper.scrollTop = 0
    },

    handleSizeChange(val) { 
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },
    handleCurrentChangeDetails(val) { 
      this.pageIdxDetails = val;
      this.getUserBalancesDetailList(val - 1);
    },

    handleSizeChangeDetails(val) {
      this.pageIdxDetails = 0;
      this.pageSizeDetails = val;
      this.getUserBalancesDetailList(0);
    },

    //获取明细
    userBalancesDetail(item) {
      this.detailPhone = item.phone;
      this.detailName = item.name;
      this.pageIdxDetails = 0;
      this.quertDetailData = { ...item };
      this.listDataDetail = [];
      this.getUserBalancesDetailList(0);
    },

    getUserBalancesDetailList(pageIdxDetails) {
      let data = {
        pageSize: this.pageSizeDetails,
        pageIdx: pageIdxDetails,
        userID: this.quertDetailData.id,
        orgID: this.quertDetailData.orgID,
      };

      if (Array.isArray(this.daterange)) {
        data.startTS = parseInt(this.daterange[0].getTime() / 1000);
        data.endTS = parseInt(
          this.daterange[1].getTime() / 1000 + 60 * 60 * 24 - 1
        );
      }

      const loading = Loading.service({
        lock: true,
        text: "正在请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      axios({
        method: "post",
        url: "wallets/details",
        data: data,
      })
        .then((value) => {
          this.listDataDetail = [];
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
            return;
          }
          if (value && value.data && value.data.data) {
            this.itemTotalDetails = value.data.total;
            // this.listDataDetail =value.data.data
            this.detailPhone = value.data.data[0].phone;
            this.detailName = value.data.data[0].name;
            value.data.data.forEach((item) => {
              item.amount = new Decimal(item.amount)
                .div(new Decimal(100))
                .toNumber();
              item.changeTime = Utils.long2second(item.changeTime * 1000);
              this.listDataDetail.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });

      this.userDetailsDialogVisible = true;

      // 查询明细信息
    },

    initQuery() {
      this.pageIdx = 0;
      this.query(0);
    },

    //列表查询
    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        pageSize: this.pageSize,
        pageIdx: pageIdx,
        phoneOrName: this.phoneOrName,
        houseName: this.queryHouseName,
      };

      const loading = Loading.service({
        lock: true,
        text: "正在请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
      // 如果 isRunDrawLine=true  刷新饼图数据
      if (this.isRunDrawLine) {
        this.drawLine();
      }
      axios({
        method: "post",
        url: "wallets",
        data: data,
      })
        .then((value) => {
          this.listData = [];
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
            return;
          }
          this.itemTotal = value.data.total;
          if (value && value.data && value.data.data) {
            value.data.data.forEach((item) => {
              item.balance = new Decimal(item.balance)
                .div(new Decimal(100))
                .toNumber();
              this.listData.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    },
  },
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.el-input-group__prepend {
  width: 140px !important;
}
.el-input-group--prepend {
  margin-bottom: 10px;
}
</style>

<style lang="scss" scoped>
@import "../../style.css";
main {
  margin-top: 10px;
}
.div-2-title {
  max-width: 80px;
  min-width: 70px;
}
</style>